import { APP_ENV, APP_RELEASE, RAVEN_PUBLIC_DSN } from "config/globals";

if (window.Raven) {
  Raven.config(RAVEN_PUBLIC_DSN, {
    environment: APP_ENV,
    release: APP_RELEASE,
    tags: {
      locale: I18n.locale,
    },
    maxBreadcrumbs: 50,
  }).install();
}



// WEBPACK FOOTER //
// ./src/app/initializers/raven.js